import { useTranslation } from 'react-i18next'
import { Badge } from '@ludus/ui'
import type { Manager } from '@ludus/core'

export function IdentityBadges({ manager }: { manager: Manager }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {manager.identities.length === 0 ? (
        <Badge tone="muted" size="sm">
          {t('pages.managers.createdHere')}
        </Badge>
      ) : (
        manager.identities.map((identity) => (
          <Badge
            key={`${identity.adapterKind}:${identity.externalRef}`}
            tone="info"
            size="sm"
            className="normal-case tracking-normal"
            title={identity.displayName ?? undefined}
          >
            <span className="font-medium opacity-80">{identity.adapterKind}</span>
            <span aria-hidden="true">·</span>
            <span className="font-mono">{identity.externalRef}</span>
          </Badge>
        ))
      )}
      {!manager.isActive && (
        <Badge tone="warning" size="sm">
          {t('pages.managers.inactive')}
        </Badge>
      )}
    </div>
  )
}
